import { ChipDetailsResponse, OwnerDetailResponse }
 from '../models/chip-details.model';

import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { addSignatures } from './pdf-render/add-sigantures';
import { addressContent } from './pdf-render/address-content';
import { animalInformation } from './pdf-render/animal-information';
import { checkboxSvg } from './pdf-render/checkbox-canvas';
import { dateToGBFormatHelper } from '@shared/helpers/date-to-GB-format.helper';
import { ownerInformation } from './pdf-render/owner-information';
import { pdfRenderConfirmationSvg } from './pdf-render/pdf-render-confirmation-svg';

export async function generateChangeOwnerPdf(
    {
        codeInfo,
        registrationDetails,
        animal,
        owner,
        veterinarian,
    }: ChipDetailsResponse,
    previouseOwner: OwnerDetailResponse,
): Promise<string> {
    const pdfMakeModule = await import('pdfmake/build/pdfmake.min');
    const pdfFonts = await import('pdfmake/build/vfs_fonts');

    pdfMakeModule.vfs = pdfFonts.vfs;


    const docDefinition: TDocumentDefinitions = {
        pageSize: 'A4',
        pageMargins: [30, 20, 20, 30],
        content: [

            {
                columns: [
                    { text: 'DOKUMENT IDENTIFIKIMI', color: 'red', bold: true, fontSize: 16 },
                    {
                        width: '*',
                        stack: [
                            {
                                image: 'logo', // base64 or path
                                width: 130,
                                alignment: 'right',
                            },
                            {
                                text: codeInfo?.registrationUniqueId || '',
                                alignment: 'right',
                                color: 'red',
                                bold: true,
                                margin: [0, 4, 25, 0],
                            },
                        ],
                    },
                ],
            },
            {
                table: {
                    widths: ['auto', 'auto', '*'],
                    body: [
                        [
                            {
                                text: 'Mikroçip',
                                bold: true,
                                border: [false, false, false, false],
                                margin: [0, 13, 5, 0],
                            },
                            {
                                text: codeInfo.code,
                                fontSize: 16,
                                border: [true, true, true, true],
                                margin: 10,
                            },
                            {
                                text: '',
                                border: [false, false, false, false],
                            },
                        ],
                    ],
                },
                margin: [0, 10, 0, 10],
            },
            {
                table: {
                    widths: ['auto', '*', '*'],
                    body: [
                        [
                            {
                                text: 'Veterineri',
                                bold: true,
                                border: [false, false, false, false],
                            },
                            {
                                text: `${veterinarian.name} ${veterinarian.surname}`,
                                colSpan: 2,
                                border: [false, false, false, true],
                            },
                            '',
                        ],
                    ],
                },
                margin: [0, 10, 0, 10],
            },

            // PREVIOUS OWNER INFORMATION
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'Informacioni i pronarit të mëparshëm',
                                bold: true,
                                border: [false, false, false, true],
                            },
                        ],
                    ],
                },
                margin: [0, 0, 0, 4],
            },
            ...ownerInformation(previouseOwner),
            ...addressContent(previouseOwner.addresses),
            // OWNER INFORMATION
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'Informacioni i pronarit të ri',
                                bold: true,
                                border: [false, false, false, true],
                            },
                        ],
                    ],
                },
                margin: [0, 0, 0, 4],
            },
            ...ownerInformation(owner),
            ...addressContent(owner.addresses),
            // Animal
            ...animalInformation(animal, registrationDetails.date),
            // Animal adress
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'Adresa e kafshës',
                                bold: true,
                                border: [false, false, false, true],
                            },
                        ],
                    ],
                },
            },
            ...addressContent(animal.addresses),
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                alignment: 'left',
                                columns: [
                                    { text: 'Vendndodhja e çipit', margin: [0, 3, 10, 0], width: 'auto' },
                                    checkboxSvg(+animal.chipLocation === 1, 12),
                                    {
                                        text: 'Qafa e majtë',
                                        alignment: 'right',
                                        margin: [10, 3, 45, 0],
                                        width: 'auto',
                                    },
                                    checkboxSvg(+animal.chipLocation === 2, 12),
                                    {
                                        text: 'Qafa (zona e qafës)',
                                        alignment: 'right',
                                        margin: [10, 3, 45, 0],
                                        width: 'auto',
                                    },
                                ],
                                border: [true, true, true, true],
                                margin: [0, 0, 30, 0],
                            },
                        ],
                    ],
                },
            },
            {
                columns: [
                    ...addSignatures(registrationDetails)
                ],
                margin: [50, 20, 0, 0],
            },
            ...pdfRenderConfirmationSvg(registrationDetails),
            {
                text: `Data ${dateToGBFormatHelper(registrationDetails.date)}`,
                alignment: 'right',
                fontSize: 9,
                margin: [0, 10, 0, 0],
            },
            {
                text: `Përgjegjës për përpunimin e të dhënave:`,
                bold: true,
                alignment: 'justify',
                fontSize: 7,
                margin: [0, 10, 0, 3],
            },
            {
                text: `RKSH – Regjistri Kombëtar i Kafshëve Shtëpiake, autoritet përgjegjës për administrimin e regjistrit të identifikimit të kafshëve shtëpiake në Republikën e Shqipërisë.`,
                alignment: 'justify',
                fontSize: 7,
            },
            {
                text: `Qëllimi i përpunimit:`,
                bold: true,
                alignment: 'justify',
                fontSize: 7,
                margin: [0, 3],
            },
            {
                text: `Përpunimi i të dhënave personale kryhet për regjistrimin e mikroçipit të kafshës shtëpiake në databazën RKSH, me qëllim identifikimin, gjurmueshmërinë e saj në rast humbjeje, si dhe për përmbushjen e detyrimeve ligjore në fushën e mbrojtjes dhe mirëqenies së kafshëve.`,
                alignment: 'justify',
                fontSize: 7,
            },
            {
                text: `Baza ligjore:`,
                bold: true,
                alignment: 'justify',
                fontSize: 7,
                margin: [0, 3],
            },
            {
                text: `Përpunimi i të dhënave bazohet në kërkesën për regjistrim të mikroçipit dhe kryhet në përputhje me legjislacionin në fuqi në Republikën e Shqipërisë, përfshirë Ligjin Nr. 9887, datë 10.03.2008, “Për mbrojtjen e të dhënave personale” (i ndryshuar).`,
                alignment: 'justify',
                fontSize: 7,
            },
            {
                text: `Marrësit e të dhënave:`,
                bold: true,
                alignment: 'justify',
                fontSize: 7,
                margin: [0, 3],
            },
            {
                text: `Të dhënat personale mund t’u komunikohen vetëm subjekteve dhe institucioneve kompetente, përfshirë autoritetet publike ose subjektet e autorizuara , vetëm për qëllime ligjore dhe administrative, në përputhje me legjislacionin në fuqi.`,
                alignment: 'justify',
                fontSize: 7,
            },
            {
                text: `Të drejtat e subjektit të të dhënave:`,
                bold: true,
                alignment: 'justify',
                fontSize: 7,
                margin: [0, 3],
            },
            {
                text: `Subjekti i të dhënave ka të drejtë të kërkojë akses, korrigjim, përditësim ose fshirje të të dhënave personale, sipas parashikimeve të Ligjit Nr. 9887, datë 10.03.2008.`,
                alignment: 'justify',
                fontSize: 7,
            },
        ],

        images: {
            logo: {url: 'https://ctvmngvzsmtrbqckpgxq.supabase.co/storage/v1/object/public/assets/logo.png'},
        },

        defaultStyle: {
            fontSize: 10,
        },
    };

    // pdfMakeModule.createPdf(docDefinition).open();
    return new Promise((resolve) => {
        pdfMakeModule.createPdf(docDefinition).getBase64((generatePdf: string) => resolve(generatePdf));
    });
}
